(function () {
  // Don't run loader in theme editor preview
  const inEditor = !!(window.Shopify && Shopify.designMode);

  const isHome =
    document.body.classList.contains("template-index") ||
    window.location.pathname === "/" ||
    window.location.pathname.replace(/\/+$/, "") === "";


    // ✅ Only show loader once per tab session
  const LOADER_KEY = "mr_loader_shown_v1";

  function skipLoaderInstantly() {
    const loaderEl =
      document.getElementById("siteLoader") || document.querySelector(".load");
    if (loaderEl) {
      loaderEl.classList.remove("is-leaving");
      loaderEl.style.display = "none";
    }
    unlockScroll(); // safe even if not locked
  }


window.addEventListener("pageshow", (e) => {
  if (!isHome) return;

  // Only force-skip loader on bfcache restore
  if (e.persisted) {
    sessionStorage.setItem(LOADER_KEY, "1");
    skipLoaderInstantly();
  }
});
  


  function initVideoAutoplay() {
    const v = document.getElementById("montage");
    if (!v) return;

    v.muted = true;
    v.playsInline = true;

    const tryPlay = () => v.play().catch(() => {});

    tryPlay();

    ["touchstart", "click"].forEach((evt) =>
      document.addEventListener(evt, tryPlay, { once: true, passive: true })
    );
  }

  function msFromCssTime(value) {
    if (!value) return 0;
    const parts = String(value)
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

    const toMs = (v) => {
      if (v.endsWith("ms")) return parseFloat(v);
      if (v.endsWith("s")) return parseFloat(v) * 1000;
      return parseFloat(v) || 0;
    };

    return Math.max(...parts.map(toMs), 0);
  }

  const EXCERPT_TEXT = "MAXWELL ROSE: A new womenswear label";

  function typeText(el, text, speedMs) {
    // speedMs can be a number (simple), or keep your full options later
    return new Promise((resolve) => {
      if (!el) return resolve();
      el.textContent = "";
      el.classList.add("is-visible");
      let i = 0;

      const step = () => {
        if (i >= text.length) return resolve();
        el.textContent += text.charAt(i++);
        setTimeout(step, speedMs);
      };

      setTimeout(step, 250);
    });
  }

  function lockScroll() {
    const scrollY = window.scrollY;
    document.body.dataset.scrollY = String(scrollY);

    document.documentElement.classList.add("is-locked");
    document.body.classList.add("is-locked");

    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
  }

  function unlockScroll() {
    const scrollY = parseInt(document.body.dataset.scrollY || "0", 10);

    document.documentElement.classList.remove("is-locked");
    document.body.classList.remove("is-locked");

    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";

    window.scrollTo(0, scrollY);
  }

  function initLoader() {
    // Gate: only homepage gets loader
    if (!isHome) {
      const loaderEl =
        document.getElementById("siteLoader") || document.querySelector(".load");
      if (loaderEl) loaderEl.remove();
      unlockScroll();
      return;
    }
    if (sessionStorage.getItem(LOADER_KEY) === "1") {
    skipLoaderInstantly();
    return;
    }
    
    sessionStorage.setItem(LOADER_KEY, "1");


    const loader = document.getElementById("siteLoader") || document.querySelector(".load");
    const rMark = document.getElementById("rMark");
    const exploreBtn = document.getElementById("exploreBtn");
    const strokePath = document.querySelector("svg.r-stroke path.r-stroke");
    const excerptEl = document.getElementById("loaderExcerpt");

    if (!loader || !rMark || !exploreBtn || !strokePath) {
      console.warn("Intro loader: missing elements", { loader, rMark, exploreBtn, strokePath });
      skipLoaderInstantly(); // ✅ avoid getting stuck locked
      return;
    }

    lockScroll();

    let introReady = false;
    exploreBtn.disabled = true;

    // stroke setup
    const length = strokePath.getTotalLength();
    strokePath.style.strokeDasharray = length;
    strokePath.style.strokeDashoffset = length;
    strokePath.getBoundingClientRect(); // reflow

    const computed = getComputedStyle(strokePath);
    const dur = msFromCssTime(computed.animationDuration);
    const delay = msFromCssTime(computed.animationDelay);
    const strokeTotalMs = dur + delay > 50 ? dur + delay : 1400;

    // hover behavior
    exploreBtn.addEventListener("mouseenter", () => {
      exploreBtn.classList.remove("is-blinking");
      exploreBtn.classList.add("is-hovered");
    });

    exploreBtn.addEventListener("mouseleave", () => {
      if (!introReady) return;
      exploreBtn.classList.add("is-blinking");
      exploreBtn.classList.remove("is-hovered");
    });

    exploreBtn.addEventListener("click", () => {
      if (!introReady) return;

      sessionStorage.setItem(LOADER_KEY, "1"); // ✅ here

      exploreBtn.classList.remove("is-blinking");
      exploreBtn.classList.add("is-clicked");
      loader.classList.add("is-leaving");

     setTimeout(() => {
        loader.style.display = "none";
        unlockScroll();
      },    950);
    });
    (async () => {
      await new Promise((r) => setTimeout(r, strokeTotalMs));
      await typeText(excerptEl, EXCERPT_TEXT, 18);

      rMark.classList.add("is-filled");
      exploreBtn.classList.add("is-visible", "is-blinking");

      exploreBtn.disabled = false;
      introReady = true;
    })();
  }

  document.addEventListener("DOMContentLoaded", () => {
    initVideoAutoplay(); // always
    initLoader();        // only home
  });
})();

document.addEventListener("DOMContentLoaded", () => {
  const body = document.body;

  if (body.classList.contains("template-index")) {
    body.classList.add("hero-locked");
  } else {
    body.classList.remove("hero-locked");
  }
});

document.addEventListener("click", (e) => {
  const trigger = e.target.closest(".hero-exit, .siteNav a");
  if (!trigger) return;

  document.body.classList.remove("hero-locked");
});

